import createStatusChipSelect from '@/components/statuses/factory/createStatusChipSelect';
import TALENT_STATUSES from '@/components/statuses/TalentStatus/options';
import TalentStatus from '@/components/statuses/TalentStatus/TalentStatus';

import ChipSelect from './ChipSelect';

const TalentStatusSelect = createStatusChipSelect({
  options: TALENT_STATUSES,
  defaultSx: {
    gap: ({ spacing }) => spacing(2)
  },
  StatusIndicatorComponent: TalentStatus,
  translationNamespace: 'filters',
  ChipSelectComponent: ChipSelect
});

export default TalentStatusSelect;
